import { FC, useEffect } from 'react';
import { Button, Flex, Typography } from 'antd';
import {
  SDropdown,
  SInput,
  ErrorMessage,
  SLabelTitle,
  ModalDialog,
} from '../..';
import { IProps } from './type';
import styles from './index.module.scss';
import globalStyles from '../../../assets/styles/index.module.scss';
import { PlusOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { formatISOString } from '../../../utils/functions';
import { modalTypes } from '../../../assets/enums';

const UserModal: FC<IProps> = (props) => {
  const { getFieldProps, setFieldValue, values, errors, touched } =
    props.formik;

  const navigate = useNavigate();

  const handleClickCreateProfile = () =>
    navigate('/user-profiles-and-authorisation/profile-settings');

  useEffect(() => {
    if (values.organization) {
      props.setSelectedOrganization(values.organization);
    }
  }, [values.organization, props.setSelectedOrganization]);

  return (
    <ModalDialog
      title={props.title}
      subTitle={props.subTitle}
      open={props.open}
      handleOk={props.handleSubmit}
      handleCancel={props.handleCancel}
    >
      <Flex gap="middle" vertical>
        <Flex vertical gap="small">
          <SLabelTitle>Şirket Bilgileri</SLabelTitle>
          <Flex justify="space-between" gap="small">
            <Flex vertical gap="small" className={globalStyles.widthOneThird}>
              <SDropdown
                id="organization"
                value={
                  props.organizations.find(
                    (item) => item.id === values.organization,
                  )?.name
                }
                placeholder="Şirket Seçiniz"
                options={props.organizations.map((item) => ({
                  label: item.name,
                  value: item.id,
                }))}
                onChange={(value) => setFieldValue('organization', value)}
              />
              {touched.organization && errors.organization && (
                <ErrorMessage>{errors.organization}</ErrorMessage>
              )}
            </Flex>
            <Flex vertical gap="small" className={globalStyles.widthOneThird}>
              <SInput
                placeholder="Departman Adı"
                {...getFieldProps('department')}
              />
              {touched.department && errors.department && (
                <ErrorMessage>{errors.department}</ErrorMessage>
              )}
            </Flex>
            <Flex vertical gap="small" className={globalStyles.widthOneThird}>
              <SInput
                placeholder="Pozisyon Adı"
                {...getFieldProps('position')}
              />
              {touched.position && errors.position && (
                <ErrorMessage>{errors.position}</ErrorMessage>
              )}
            </Flex>
          </Flex>
        </Flex>
        <Flex vertical gap="small">
          <SLabelTitle>Kullanıcı Bilgileri</SLabelTitle>
          <Flex justify="space-between" gap="small">
            <Flex vertical gap="small" className={globalStyles.widthHalf}>
              <SInput placeholder="İsim" {...getFieldProps('first_name')} />
              {touched.first_name && errors.first_name && (
                <ErrorMessage>{errors.first_name}</ErrorMessage>
              )}
            </Flex>
            <Flex vertical gap="small" className={globalStyles.widthHalf}>
              <SInput placeholder="Soyisim" {...getFieldProps('last_name')} />
              {touched.last_name && errors.last_name && (
                <ErrorMessage>{errors.last_name}</ErrorMessage>
              )}
            </Flex>
          </Flex>
        </Flex>
        <Flex vertical gap="small">
          <SLabelTitle>İletişim Bilgileri</SLabelTitle>
          <Flex justify="space-between" gap="small">
            <Flex vertical gap="small" className={globalStyles.widthHalf}>
              <SInput placeholder="Email" {...getFieldProps('email')} />
              {touched.email && errors.email && (
                <ErrorMessage>{errors.email}</ErrorMessage>
              )}
            </Flex>
            <Flex vertical gap="small" className={globalStyles.widthHalf}>
              <SInput
                placeholder="Telefon"
                {...getFieldProps('phone_number')}
              />
              {touched.phone_number && errors.phone_number && (
                <ErrorMessage>{errors.phone_number}</ErrorMessage>
              )}
            </Flex>
          </Flex>
        </Flex>
        <Flex vertical gap="small">
          <SLabelTitle>Profil Bilgileri</SLabelTitle>
          <Flex justify="space-between">
            <Flex vertical gap="small" className={globalStyles.widthOneThird}>
              <SDropdown
                id="role"
                value={
                  props.roles.find((item) => item.id === values.role)
                    ?.external_name
                }
                placeholder="Profil"
                options={props.roles.map((role) => ({
                  label: role.external_name,
                  value: role.id,
                }))}
                onChange={(value) => setFieldValue('role', value)}
              />
            </Flex>
            <Flex vertical gap="small" className={globalStyles.widthOneThird}>
              <Button
                className={styles.addButton}
                onClick={handleClickCreateProfile}
              >
                <PlusOutlined className={styles.buttonIcon} />
                <div className={styles.buttonText}>Profil Oluştur</div>
              </Button>
            </Flex>
          </Flex>
        </Flex>
        {props.type === modalTypes.EDIT && (
          <>
            <Flex justify="space-between">
              <SLabelTitle>Oluşturan Kullanıcı</SLabelTitle>
              <Typography className={styles.labelValue}>
                {values.created_by}
              </Typography>
            </Flex>
            <Flex justify="space-between">
              <SLabelTitle>Kayıt Tarihi</SLabelTitle>
              <Typography className={styles.labelValue}>
                {values.created_at ? formatISOString(values.created_at) : null}
              </Typography>
            </Flex>
          </>
        )}
      </Flex>
    </ModalDialog>
  );
};

export default UserModal;
